<div ui-view="full-width-header"></div>
<div flex layout="column" ui-view></div>
<!-- Keep the ui-view and router-outlet RIGHT NEXT TO EACH OTHER -->
<router-outlet></router-outlet>
